export function timeConverter(t) {
  let a;
    if (typeof t === 'number' && isFinite(t)) {
      a = new Date(t * 1000)
    } else if(typeof t === 'string' || t instanceof String) {
      a = new Date(t)
    }
      
	let months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	]
	let year = a.getFullYear()
	let month = months[a.getMonth()]
	let date = a.getDate()
	let hour = a.getHours()
	let min = a.getMinutes() < 10 ? '0' + a.getMinutes() : a.getMinutes()
	let sec = a.getSeconds() < 10 ? '0' + a.getSeconds() : a.getSeconds()
	let time =
		date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec
	return time
}

export function emailValidator (value) {
	return (value && !!value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) || false
}